<ng-container *transloco="let t;">
    <div class="position-relative">
        <label class="col-form-label p-0" for="name">{{ _field.label }}</label>
        <div class="input-group input-group-merge align-items-center">
            @if(formGroup.get('recurring')?.value){
                <div class="input-group-prepend">
                    <span class="input-group-text px-0 border-0 text-primary me-50 text-muted">{{ t('Document signing or reminder placeholder text (Template/Document - section) - Every') }}</span>
                </div>
            }
            <input
                type="text"
                [disabled]="!canEdit"
                class="form-control signatureDueDatesInput"
                [ngModel]="formGroup.get('signing_reminder')?.value ?? _field.value"
                placeholder="-"
                aria-label="-"
                (ngModelChange)="onSigningReminderChange($event)"
            />
            <div class="input-group-append">
                <span class="input-group-text px-0 border-0 text-primary">{{t("Document signing or reminder days text (Template/Document - section) - Days")}}</span>
            </div>
        </div>
        <div
            class="custom-control custom-checkbox signReminderCheck"
            placement="auto"
            [autoClose]="true"
            triggers="hover"
            [ngbTooltip]='t("Document signing or reminder tooltip text (Template/Document - section) - Recurring")'
        >
            <input type="checkbox" [disabled]="!canEdit" class="custom-control-input" id="recurring" [(ngModel)]="_field.recurring" (change)="onRecurringChange($event.target.checked)" />
            <label class="custom-control-label" for="recurring"></label>
        </div>
    </div>
</ng-container>
